module.exports = __webpack_public_path__ + "media/images/press_kit/virgin_voyages/email/top-small-c9a21b349e207fa9537cc667a0ca2a78.png";